module.exports = __webpack_public_path__ + "img/mineA.fcf9097f.png";